module.exports = __webpack_public_path__ + "static/media/deductibleN.2dd30b12.png";